/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
import throttle from 'lodash.throttle';

export default {
	data() {
		return {
			canScroll: true,
		};
	},
	methods: {
		throttleMe: throttle(
			function (event) {
				const {target, deltaX, deltaY} = event;
				if (this.getCanScroll) {
					const slider = target.closest('.show-slider-arrow .slider');
					if (!slider) return;
					// check scroll direction - or +
					const direction = Math.sign(deltaY + deltaX) > 0 ? 'prev' : 'next';
					this.startSliding(slider, direction);
				}
			},
			200,
			{leading: true, trailing: false},
		),
		toggleCanIScroll(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			// ignore any transition that are not transform
			if (e.propertyName !== 'transform') return;
			// add class to cache already listening
			e.target.classList.add('listening');
			// only allow types that are not "running"
			this.canScroll = !!(e.type !== 'transitionrun');
		},
		handleSliderClick: throttle(
			function ({target}, direction = 'next') {
				if (this.getCanScroll) {
					// get slider: slider is a sibling of the directional buttons
					const slider = direction === 'next' ? target.previousElementSibling : target.nextElementSibling;
					this.startSliding(slider, direction);
				}
			},
			200,
			{leading: true, trailing: false},
		),
		isIntersecting(slider) {
			return Promise.resolve(slider.querySelector('.observer-last').classList.contains('inview'));
		},
		async startSliding(slider, direction) {
			// get slides
			let moveToSlide;
			const current = slider.querySelector('.current') || slider.firstElementChild;

			// prep next slide
			if (direction === 'prev') {
				moveToSlide = current.previousElementSibling;

				while (moveToSlide && this.selectedIsWithinParent(slider, moveToSlide))
					moveToSlide = moveToSlide.previousElementSibling;
			} else if (
				direction === 'next' &&
				!this.selectedIsWithinParent(slider, slider.querySelector('.observer-last'))
			)
				moveToSlide = slider.querySelector('.current + li.slide');
			if (!moveToSlide) return;
			// update classes then scroll slide into position
			moveToSlide.classList.toggle('current', current.classList.remove('current'));
			this.scrollToElem(slider, moveToSlide, direction);
		},
		async scrollToElem(slider, slide, direction = null) {
			this.canScroll = false;
			let amount;
			// set smaller chips to scroll to the right of the container instead of the left
			amount = slide.querySelector('.observer-last')
				? slider.scrollWidth - slider.parentNode.offsetWidth
				: slide.offsetLeft;
			amount = Math.sign(amount) < 0 ? amount : -Math.abs(amount);
			const regexMatch = slider.style.transform?.match(/\((.*)(?=px,)/);
			if (`${amount}` === ((regexMatch && regexMatch[1]) || '') && direction)
				return this.startSliding(slider, direction);

			return (slider.style.transform = `translate(${amount}px, 0)`);
		},
		selectedIsWithinParent(slider, slide) {
			const {left, right} = slider.parentNode.getBoundingClientRect();
			const {left: sleft, right: sright} = slide.getBoundingClientRect();
			return sleft >= left && sright <= right;
		},
		async scrollToSelected() {
			await this.$nextTick();
			const sliders = this.$el.querySelectorAll('.show-slider-arrow .slider');

			if (sliders) {
				for (const slider of sliders) {
					// only add listener if not already listening
					if (!slider.classList.contains('listening')) {
						slider.addEventListener('transitionrun', this.toggleCanIScroll, {capture: true});
						slider.addEventListener('transitionend', this.toggleCanIScroll, {capture: true});
						slider.addEventListener('transitioncancel', this.toggleCanIScroll, {capture: true});
					}

					const slide = slider.querySelector('li.selected');
					if (slide) {
						// add classes
						slide.classList.toggle(
							'current',
							slider.querySelector('li.current').classList.remove('current'),
						);
						// check if already in view
						if (this.selectedIsWithinParent(slider, slide)) continue;
						// scroll to selected chip
						this.scrollToElem(slider, slide);
						this.canScroll = true;
					}
				}
			}
		},
		removeListeners() {
			for (const slider of this.$el.querySelectorAll('.chips-wrap.show-slider-arrow > .slider.listening')) {
				slider.removeEventListener('transitionrun', this.toggleCanIScroll, {capture: true});
				slider.removeEventListener('transitionend', this.toggleCanIScroll, {capture: true});
				slider.removeEventListener('transitioncancel', this.toggleCanIScroll, {capture: true});
			}
			this.$emit('sliderListenersRemoved');
		},
	},
	computed: {
		getCanScroll() {
			return this.canScroll;
		},
	},
	async updated() {
		this.canScroll = true;
		await this.$nextTick();
		this.scrollToSelected();
	},
	beforeDestroy() {
		this.removeListeners();
	},
};
